export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const ADD_USER = 'ADD_USER';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
